import { inject, Injectable } from '@angular/core'
import { HttpService } from '@bases/http.service'
import { INTEGRATION_SERVER_URL } from '@core/constants/constant.data'
import { IntegrationLogsResponse } from '@core/models/integration-logs.model'
import Keycloak from 'keycloak-js'

@Injectable({
  providedIn: 'root',
})
export class IntegrationLogsService extends HttpService {
  private readonly _keycloak = inject(Keycloak)

  async getLogs(linesNumber: number, logFilter: string): Promise<IntegrationLogsResponse> {
    if (linesNumber < 1 || linesNumber > 10000) {
      this._toasterService.openSnackBarError('Lines number must be between 1 and 10000.')
      return {
        success: false,
        logs: [],
        count: 0,
        total_available: 0,
        error: 'Failed to load logs. Lines number must be between 1 and 10000.',
      }
    }

    const url =
      INTEGRATION_SERVER_URL +
      `logs?lines_number=${encodeURIComponent(String(linesNumber))}&filter=${encodeURIComponent(logFilter.toLowerCase())}`

    const headers = {
      Authorization: `Bearer ${this._keycloak.token}`,
    }

    const response = (await this.GETwithHeaders(url, headers)) as IntegrationLogsResponse | null

    if (!response) {
      return {
        success: false,
        logs: [],
        count: 0,
        total_available: 0,
        error: 'Failed to load logs.',
      }
    }

    return response
  }
}
